import React, { useState } from 'react';
import { MessageCircleIcon, HeadphonesIcon } from 'lucide-react';
import { ChatAgent } from './ChatAgent';
import { whatsappLink } from '../utils/contact';
import { company } from '../data/company';
export function FloatingActions() {
  const [chatOpen, setChatOpen] = useState(false);
  return <>
      <ChatAgent open={chatOpen} onClose={() => setChatOpen(false)} data-id="element-68" data-mp="fa6i40hhwdp" />

      <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3 sm:right-6" data-id="element-69" data-mp="5e4nr1iszcvp">
        <a href={whatsappLink()} target="_blank" rel="noreferrer" className="group flex items-center gap-2 rounded-sm bg-[#25D366] px-4 py-3 text-sm font-semibold text-[#0a2f16] shadow-lg transition-colors duration-150 hover:bg-[#1fbe5a]" aria-label={`Chat with the ${company.shortName} trading desk on WhatsApp`} data-id="element-70" data-mp="9engqywfmozh">
          <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-71" data-mp="2g7zdc0ks25cn" />
          <span data-id="element-72" data-mp="2l597tun0x77c">WhatsApp</span>
        </a>

        <button type="button" onClick={() => setChatOpen(v => !v)} aria-expanded={chatOpen} className="flex items-center gap-2 rounded-sm border border-gold bg-ink px-4 py-3 text-sm font-semibold text-gold-light shadow-lg transition-colors duration-150 hover:bg-gold hover:text-ink" data-id="element-73" data-mp="g1ssqc3taoab">
          <HeadphonesIcon className="h-5 w-5" aria-hidden="true" data-id="element-74" data-mp="2bpfgamwu4x0" />
          {chatOpen ? 'Close help centre' : 'Ask Kito — Help Centre'}
        </button>
      </div>
    </>;
}